<template>
<div>
    <v-container fluid grid-list-md class="padding_10">
      <v-layout row wrap style="padding: 0px 10px 0px 10px; align-content: center; align-items: center;    display: flex;
    justify-content: space-between;">
        <v-flex xm12 sm12 md12 lg8>
          <v-expansion-panel class="mb-4">
            <v-expansion-panel-content>
              <template v-slot:header>
                <div>Filters</div>
              </template>
              <v-layout row wrap style="padding: 0px 10px 0px 10px; align-content: center; align-items: center;"
                        class="index_header">
                <v-flex sm4 md2 lg2 style="margin-right: 10px;">
                  <v-checkbox
                      label="Cancelled"
                      :value="filters.Cancelled"
                      v-model="filters.Cancelled"
                      @change="filterIsCancelled($event)"
                      class="request_checkbox"
                      :color="'black'"
                  ></v-checkbox>
                </v-flex>
                <v-flex sm4 md2 lg2 style="margin-right: 5px;">
                  <v-checkbox
                      label="Delayed"
                      :value="filters.delayed"
                      v-model="filters.delayed"
                      @change="filterIsDelayed($event)"
                      class="request_checkbox"
                      :color="'black'"
                  ></v-checkbox>
                </v-flex>
                <v-flex sm4 md2 lg2>
                  <v-checkbox
                      label="Other"
                      :value="filters.other"
                      v-model="filters.other"
                      @change="filterIsModified($event)"
                      class="request_checkbox"
                      :color="'black'"
                  ></v-checkbox>
                </v-flex>

                <v-flex sm12 md6 lg4 style="padding-top: 17px;">
                  <v-autocomplete
                      v-model="filters.title"
                      :items="title_list"
                      placeholder="Search By Description"
                      item-value="id"
                      item-text="description"
                      clearable solo flat
                      :search-input.sync="search_title"
                      @change="searchByTitle()"
                  ></v-autocomplete>
                </v-flex>

                <v-flex sm12 md6 lg2>
                  <v-text-field
                      v-model="filters.train_number"
                      label="Train Number"
                      clearable
                      solo
                      flat
                      @input="getList()"
                  ></v-text-field>
                </v-flex>

                <v-flex sm12 md6 lg3>
                  <v-menu
                      v-model="filterDateMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="filters.date"
                          label="Service Date"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          clearable
                          solo
                          flat
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="filters.date"
                        @input="filterDateMenu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>

              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>


        <v-flex xs12 sm12 md12 lg3>
          <v-flex xs12 sm12 md12 lg10 style="display: flex; justify-content: center; padding-bottom: 27px;">
            <v-btn slot="activator" large class="white--text add_announcement text-xs-center" >
              <router-link to="/trip-updates/create" class="white--text">
                <v-icon color="#bbbbc6" class="white--text mr-2">edit</v-icon>
                Create Train Update
              </router-link>
            </v-btn>
          </v-flex>
        </v-flex>

      </v-layout>

    <v-layout row wrap class="table_opacity_8">
      <v-flex xs12 class="text-xs-right">
        <strong>Total Records: {{ total_items }}</strong>
      </v-flex>
      <v-flex xs12>
        <v-data-table
            no-results-text="Loading... Please wait"
            :headers="headers"
            v-model="selected"
            :items="announcement_list"
            item-key="id"
            :pagination.sync="pagination"
            :loading="loaders.announcement_list_loader"
            :total-items="total_items"
            :rows-per-page-items="[10, 20, 50, 100]">

          <template slot="items" slot-scope="props">
            <td>
                {{ props.item.description }}
            </td>

            <td v-if="props.item.local_train_number">
              {{props.item.local_train_number}}{{" - "}}
              <span v-if="props.item.local_train != null && props.item.local_train.short_code != null">
                {{props.item.local_train.short_code}} </span>

            </td>
            <td v-else>{{ "-" }}</td>

            <td v-if="props.item.type_object && props.item.type_object.title">
              <span>
                <v-chip color="#FCCECB" text-color="#F44336" v-if="props.item.type_object.title == 'Cancellations'">{{
                    props.item.type_object.title }}</v-chip>
                <v-chip color="#adcbe3" text-color="#4b86b4" v-else-if="props.item.type_object.title == 'Delays'">{{
                    props.item.type_object.title }}
                </v-chip>
                <v-chip color="#dddddd" text-color="#aaaaaa" v-else-if="props.item.type_object.title == 'Others'">{{
                    props.item.type_object.title }}
                </v-chip>
                <v-chip color="#FFE0B2" text-color="#E65100" v-else-if="props.item.type_object.title == 'Short_Terminate'">{{
                  props.item.type_object.title }}
                </v-chip>
                <v-chip color="#E1BEE7" text-color="#6A1B9A" v-else-if="props.item.type_object.title == 'Extended'">{{
                    props.item.type_object.title }}
                </v-chip>
              </span>
            </td>
            <td v-else>{{ "-" }}</td>

            <td v-if="props.item.status" style="text-transform: capitalize;">
              <span><v-chip color="#FFEDAA" text-color="#935E0D" v-if="props.item.status == 'draft'">{{
                  props.item.status }}</v-chip>
              <v-chip color="#C8E6C9" text-color="#1B5E20"
                      v-else-if="props.item.status == 'published'">{{
                  props.item.status }}</v-chip>
                <v-chip color="#d2b5a1" text-color="#794936" v-else-if="props.item.status == 'archived'">{{
                    props.item.status }}</v-chip>
              </span>
            </td>
            <td v-else>{{ "-" }}</td>

            <td>
              {{ (props.item.updated_at) | appDateTimeFormat }}
            </td>

            <td>
              <v-tooltip left><template v-slot:activator="{ on, attrs }">

                <v-btn :disabled="!checkPermission('update-trip-announcement')" v-bind="attrs"
                       v-on="on" text icon small :to="{name:'train-update-edit', params:{id:props.item.id} }">
                  <v-icon class="material-icons" color="blue">edit</v-icon>
                </v-btn>
              </template><span>Edit Train Update</span></v-tooltip>


              <v-tooltip left><template v-slot:activator="{ on, attrs }">
                <v-btn text icon small v-bind="attrs" v-on="on" :disabled="!checkPermission('delete-trip-announcement')"
                       @click="delete_trip_announcement_box = !delete_trip_announcement_box; trip_announcement_id =
                       props.item.id; trip_announcement_type_id = props.item.announcement_type_id; local_train_number = props.item.local_train_number; 
                       service_date = format(props.item.affected_till)">
                  <v-icon class="material-icons" color="red">delete</v-icon>
                </v-btn>
              </template><span>Delete Train Update</span></v-tooltip>

            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>


<!--      delete trip announcement dialog-->
      <v-dialog v-model="delete_trip_announcement_box" scrollable :overlay="false" max-width="450px"
                transition="dialog-transition"
                hide-overlay persistent>
        <v-card>
          <v-card-title primary-title>
            <span>Are you sure you wish to delete this Train Update?</span>
          </v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small @click="delete_trip_announcement_box = false">Cancel</v-btn>
            <v-btn small color="primary" @click="deleteTripAnnouncement" :loading="delete_loading">Delete</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar v-model="snackbar.display" :color="snackbar.color" :top="snackbar.top" :bottom="snackbar.bottom"
                  :left="snackbar.left" :right="snackbar.right" :timeout="snackbar.timeout">
        {{ snackbar.message }}
        <v-btn
            text
            dark
            @click="snackbar.display = false"
        >
          <v-icon
              right
              color="white"
          >
            close
          </v-icon>
        </v-btn>
      </v-snackbar>
  </v-container>
</div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
export default {
  watch:{
    pagination: {
      handler() {
        this.getList();
      },
    },
    search_title: {
      handler(newVal) {
        if (newVal != null && newVal.length > 3) {
          this.getTitleList(newVal);
        }
      },
    },
    "filters.title": {
      handler(value) {
        if (value == undefined) {
          this.filters.title = "";
        }
        this.syncFiltersToRoute();
        this.getList();
      },
    },
    "filters.train_number": {
      handler(value) {
        this.filters.train_number = value || "";
        this.syncFiltersToRoute();
        this.getList();
      },
    },
    "filters.date": {
      handler(value) {
        if (value === undefined || value === null) {
          this.filters.date = "";
        }
        this.syncFiltersToRoute();
        this.getList();
      },
    },
  },
  methods:{
    syncFiltersToRoute() {
      const query = {};

      if (this.filters.title) query.title = this.filters.title;
      if (this.filters.train_number) query.train_number = this.filters.train_number;
      if (this.filters.date) query.date = this.filters.date;
      if (this.filters.Cancelled) query.Cancelled = '1';
      if (this.filters.delayed) query.delayed = '1';
      if (this.filters.other) query.other = '1';

      this.$router.replace({ name: 'trip-announcements', query }).catch(() => {});
    },
    applyFiltersFromRoute() {
      const query = this.$route.query || {};

      this.filters.title = query.title || "";
      this.filters.train_number = query.train_number || "";
      this.filters.date = query.date || "";
      this.filters.Cancelled = query.Cancelled === '1' || query.Cancelled === true;
      this.filters.delayed = query.delayed === '1' || query.delayed === true;
      this.filters.other = query.other === '1' || query.other === true;
    },
    format(value) {
      if (!value) return '';
      return moment(value).format('YYYY-MM-DD');
    },
    filterIsCancelled(value){
      this.filters.Cancelled = value;
      this.filters.delayed = false;
      this.filters.other = false;
      this.syncFiltersToRoute();
      this.getList();
    },
    filterIsDelayed(value){
      this.filters.Cancelled = false;
      this.filters.delayed = value;
      this.filters.other = false;
      this.syncFiltersToRoute();
      this.getList();
    },
    filterIsModified(value){
      this.filters.Cancelled = false;
      this.filters.delayed = false;
      this.filters.other = value;
      this.syncFiltersToRoute();
      this.getList();
    },

    getList: function () {
      this.loaders.announcement_list_loader = true;
      this.pagination.filters = Object.assign({}, this.filters);
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/trip-update-announcement-list`, {
            params: this.pagination
          })
          .then((response) => {
            if (response.data.status == 1) {
              this.announcement_list = response.data.trip_announcement.data;
              this.total_items = response.data.trip_announcement.total;
              this.announcement_list.forEach((element) => {
                element.pin_till_date = element.pin_till
              });
            }
          })
          .catch(() => {
            this.snackbar.display = true;
            this.snackbar.message = "Something went wrong";
          })
          .finally(() => {
            {
              this.loaders.announcement_list_loader = false;
            }
          });

      this.is_loading = false;
    },
    getTitleList: function (newVal) {
      this.loaders.announcement_list_loader = true;
      axios
          .get(
              `${process.env.VUE_APP_API_URL}/api/v1/trip-announcement-title-filter`,
              {params: {searched_title: newVal}}
          )
          .then((response) => {
            if (response.data.status == 1) {
              this.title_list = response.data.titles;
            }
          })
          .catch((error) => {
            // eslint-disable-next-line no-console
            console.log(error);
            this.snackbar.message = "Error Occurred";
            this.snackbar.display = true;
          })
          .finally(() => {
            {
              this.loaders.announcement_list_loader = false;
            }
          });
      this.is_loading = false;
    },
    deleteTripAnnouncement: function () {
      this.delete_loading = true;
      let formData = new FormData()
      formData.append('trip_announcement_id', this.trip_announcement_id)
      formData.append('trip_announcement_type_id', this.trip_announcement_type_id)
      formData.append('local_train_number', this.local_train_number)
      formData.append('service_date', this.service_date)

      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/delete-trip-announcement`, formData)
          .then(response => {
            this.delete_loading = false;
            if (response.data.status == 1) {
              this.delete_trip_announcement_box = false;
              this.getList();
              this.snackbar.message = response.data.message;
              this.snackbar.display = true;
            } else if (response.data.status == 0) {
              this.delete_trip_announcement_box = false;
              this.snackbar.message = response.data.message;
              this.snackbar.display = true;
            }
          })
          .catch(() => {
            this.delete_loading = false;
            this.snackbar.message = "Something went wrong.";
            this.snackbar.display = true;
          });
    },
    searchByTitle() {
      this.getList();
    },
    applyFiltersFromRoute() {
      const { title, train_number, Cancelled, delayed, other, date } = this.$route.query;
      this.filters.title = title || "";
      this.filters.train_number = train_number || "";
      this.filters.Cancelled = Cancelled === "true";
      this.filters.delayed = delayed === "true";
      this.filters.other = other === "true";
      this.filters.date = date || "";
    },
  },
  data(){
    return{
      announcement_list: [],
      pagination: {sortBy: "updated_at", descending: false, rowsPerPage: 10},
      filters: {
        title: "",
        train_number: "",
        Cancelled: false,
        delayed: false,
        other: false,
        date: "",
      },
      headers: [
        {
          text: "Description",
          value: "description",
          align: "left",
          sortable: false,
        },
        {
          text: 'Train Number',
          value: 'train_number',
          align: 'left',
          sortable: false
        },
        {
          text: "Type",
          value: "type",
          align: "left",
          sortable: false,
        },
        {
          text: "Status",
          value: "status",
          sortable: false,
        },
        {
          text: "Updated At",
          value: "updated_at",
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          sortable: false,
        },
      ],
      total_items: 0,
        snackbar: {
          message: '',
          display: false,
          color: 'black',
          top: true,
          right: true,
          bottom: false,
          left: false,
          timeout: 2000
        },
      announcement_Loading: false,
      loaders: {
        announcement_list_loader:false,
      },
      selected: [],
      title_list: [],
      search_title: '',
      delete_trip_announcement_box: false,
      trip_announcement_id: '',
      delete_loading: false,
      filterDateMenu: false,
      current_date: moment().format('YYYY-MM-DD')
    }
  },
  mounted() {
    this.auth_user = this.$store.getters.get_user;
    this.applyFiltersFromRoute();
    this.getList();
    if (this.$route.params.message) {
      this.snackbar.display = true;
      this.snackbar.message = this.$route.params.message;
    }
  }
}
</script>
